export default __webpack_public_path__ + "static/media/pana.1a1cece6.svg";